<template>
  <div>
    <div class="title">APEC商务旅行卡申报</div>
    <div v-html="list2" class="design-html"></div>
    <div class="title">APEC商务旅行卡计划</div>
    <div v-html="list3" class="design-html"></div>
    <div class="title">APEC商务旅行卡中国实施情况</div>
    <div v-html="list1" class="design-html"></div>
  </div>
</template>
<script>
import {
  getApce1,
  getApce2,
  getApce3,
} from '@/api/service.js'

export default {
  name: 'apce',
  data () {
    return {
      list1: '',
      list2: '',
      list3: '',
    }
  },
  created () {
    getApce1().then(res => {
      this.list1 = this._.get(res, 'data.contentHtml')
      // this.list1 = this.list1.replace(/\s/g,'&nbsp;')
    })
    getApce2().then(res => {
      this.list2 = this._.get(res, 'data.contentHtml')
      // this.list2 = this.list2.replace(/\s/g,'&nbsp;')
    })
    getApce3().then(res => {
      this.list3 = this._.get(res, 'data.contentHtml')
      // this.list3 = this.list3.replace(/\s/g,'&nbsp;')
    })
  },
  methods: {
  }
}
</script>

<style scoped >
div {
  text-align: left;
  font-size: 16px;
}
.title {
  font-size: 18px;
  font-weight: bold;
  margin: 15px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/home/selfComponents/apec.vue